import {request} from './request'

// 导航
export function getThemeList(data){
    return request({
        url:"/theme/list",
        method:'post',
        data
    })
}

// 主题下的新闻分类列表
export function getThemeVo(id){
    return request({
        url:"/themeVo/" + id,
        method:'post',
    })
}

// 新闻分类下的新闻列表
export function getListByType(id){
    return request({
        url:"/news/listByType/" + id,
        method:'post',
    })
}

// 院校列表
export function getReceptionList(data){
    return request({
        url:"/school/receptionList",
        method:'post',
        data
    })
}

// 院校详情
export function getSchoolDetail(data){
    return request({
        url:"/school/getDetail",
        method:'post',
        data
    })
}

// 学习方式列表
export function getLearnStyleList(data){
    return request({
        url:"/learnStyle/list",
        method:'post',
        data
    })
}
// 获取州省列表
export function getProvinceList(data){
    return request({
        url:"/province/list",
        method:'post',
        data
    })
}

// 获取链接跳转详情
export function getSpecial(data){
    return request({
        url:"/special/get",
        method:'post',
        data
    })
}

// 新增培训订单
export function addTrainOrder(data){
    return request({
        url:"/training-order/add",
        method:'post',
        data
    })
}

// 通过id查询培训订单详情
export function getTrainOrderDetail(id){
    return request({
        url:"/training-order/get/" + id,
        method:'post',
    })
}

// 培训订单修改个人信息
export function trainOrderEdit(data){
    return request({
        // headers: {
        //     'Content-Type':'applycation/json'
        // },
        url:"/training-order/edit",
        method:'post',
        data
    })
}

// 培训订单列表
export function trainOrderList(data){
    return request({
        url:"/training-order/list",
        method:'post',
        data
    })
}

// 通用订单下单
export function commonOrder(data){
    return request({
        url:"/commonOrder/create",
        method:'post',
        data
    })
}

// 通用订单列表
export function commonOrderList(data){
    return request({
        url:"/commonOrder/page",
        method:'post',
        data
    })
}

// 删除通用订单
export function commonOrderDelete(data){
    return request({
        url:"/commonOrder/setDelFlag",
        method:'post',
        data
    })
}

// 培训订单删除
export function trainDelete(data){
    return request({
        url:"/training-order/setDelFlag",
        method:'post',
        data
    })
}

// 留学订单删除
export function orderDelete(data){
    return request({
        url:"/order/setDelFlag",
        method:'post',
        data
    })
}